module.exports = __webpack_public_path__ + "static/g2-e92029edd22872d142f9140d3b887584.png";